import { render, staticRenderFns } from "./dispatchModal.vue?vue&type=template&id=03debeda&scoped=true&"
import script from "./dispatchModal.vue?vue&type=script&lang=js&"
export * from "./dispatchModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03debeda",
  null
  
)

export default component.exports